























































































































import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import { DataTableHeader } from "vuetify/types/index";
import {
  PatientInfo,
  DefaultPatientInfo,
  DefaultReceiptSearchCondition
} from "#/model/receipt";
import { R8_CHANGE_LAW_BASE_YM } from "@/const/common";

@Component
export default class PreCheckPatientTable extends Mixins(
  UtilMixin,
  AxiosMixin
) {
  /** 選択種別 0:複数名・同一建物 1:複数名 2:同一建物 */
  @Prop({ default: () => 0 }) type!: number;

  /** 対象年月 */
  @Prop({ default: () => "" }) yearmonth!: string;

  /** 利用者一覧 */
  @Prop({ default: () => [] }) patients!: PatientInfo[];

  /** 選択済み利用者一覧 */
  @Prop({ default: () => [] }) selectedPatients!: PatientInfo[];

  /** キーワード */
  @Prop({ default: () => "" }) searchPatientName!: string;

  /** 包括型タブが表示されるか */
  @Prop({ default: () => false }) isComprehensiveVisible!: boolean;

  /** レスポンスのままフィルタリングしていない利用者一覧 */
  private unfilterPatients: PatientInfo[] = [];

  /** 選択された利用者一覧 */
  private selectPatients: PatientInfo[] = [];

  /** firestoreに保存する条件 */
  private condition = DefaultReceiptSearchCondition();

  //データテーブル
  private get headers(): DataTableHeader[] {
    const h: DataTableHeader[] = [
      {
        text: "利用者",
        value: "name",
        width: "9.2rem",
        class: "pl-4",
        cellClass: "pl-4 text-pre-wrap"
      },
      {
        text: "ふりがな",
        value: "furigana",
        width: "9rem",
        class: "pl-0",
        cellClass: "pl-0"
      },
      {
        text: "保険",
        value: "visit_type",
        width: "9rem",
        class: "pl-0",
        cellClass: "pl-0"
      },
      {
        text: "対象年月",
        value: "target_yearmonth",
        width: "calc(7.5rem - 16px)",
        class: "pl-0",
        cellClass: "pl-0"
      }
    ];
    // 管理（包括）療養費列（2026年6月以降のみ表示）
    if (this.isComprehensiveVisible) {
      h.push({
        text: "管理（包括）療養費",
        value: "is_process_comprehensive_visit",
        width: "calc(7.5rem - 16px)",
        class: "pl-0",
        cellClass: "pl-0",
        sortable: false
      });
    }
    h.push(
      {
        text: "複数名加算",
        value: "is_process_fukusu_qualif",
        width: "calc(7.5rem - 16px)",
        class: "pl-0",
        cellClass: "pl-0",
        sortable: false
      },
      {
        text: "同一建物減算",
        value: "is_process_same_building",
        width: "calc(7.5rem - 16px)",
        class: "pl-0",
        cellClass: "pl-0",
        sortable: false
      }
    );
    return h;
  }

  ALL = 0;
  FUKUSU = 1;
  SAME_BUILDING = 2;
  COMPREHENSIVE = 3;

  @Watch("patients") watchPatients() {
    this.unfilterPatients = this.patients;

    this.resetProcessPatients();
    this.setDefaultSelectPatients();
  }

  @Watch("FilterPatients") watchFilterPatients() {
    this.condition.ids = this.FilterPatients.map(patient => {
      return Number(patient.patient_id);
    });
  }

  @Watch("selectPatients", { deep: true }) watchSelectPatients() {
    this.$emit("change-select-patients", this.selectPatients);
  }

  @Watch("condition.search_cond.patient_name") watchPatientName() {
    this.$emit("change-patient-name", this.condition.search_cond.patient_name);
  }

  public async created() {
    this.unfilterPatients = this.patients;

    // 表示する表の種別によって、デフォルトのソート順を指定
    this.setDefaultSort();

    // 選択済み利用者の指定がある場合
    if (this.selectedPatients !== undefined) {
      this.selectPatients = this.selectedPatients;
    }

    // キーワードが指定されている場合
    if (this.searchPatientName !== undefined) {
      this.condition.search_cond.patient_name = this.searchPatientName;
    }
  }

  // computed: 2026年6月以降は同一建物減算を非活性にする
  get isSameBuildingDisabled(): boolean {
    return this.yearmonth >= R8_CHANGE_LAW_BASE_YM;
  }

  // computed: 全選択状態（複数名加算）
  get allFukusu(): boolean {
    return this.FilterPatients.every(item => item.is_process_fukusu_qualif);
  }
  set allFukusu(value: boolean) {
    this.FilterPatients.forEach(item => {
      item.is_process_fukusu_qualif = value;
      this.clickCheck(item);
    });
  }

  // computed: 全選択状態（同一建物減算）
  get allSameBuilding(): boolean {
    return this.FilterPatients.every(item => item.is_process_same_building);
  }
  set allSameBuilding(value: boolean) {
    this.FilterPatients.forEach(item => {
      item.is_process_same_building = value;
      this.clickCheck(item);
    });
  }

  // 選択された利用者一覧の処理対象フラグを更新
  public clickCheck(item: PatientInfo) {
    const index = this.selectPatients.findIndex(
      patient => patient.patient_id === item.patient_id
    );

    if (index !== -1) {
      if (item.is_process_fukusu_qualif || item.is_process_same_building) {
        this.selectPatients[index].is_process_fukusu_qualif =
          item.is_process_fukusu_qualif;
        this.selectPatients[index].is_process_same_building =
          item.is_process_same_building;
      } else {
        // 複数名、同一建物のどちらも処理を行わない変更の場合は選択された利用者一覧から削除する
        this.selectPatients.splice(index, 1);
      }
    } else {
      this.selectPatients.push(item);
    }
  }

  /** 初期ソート順を指定 */
  private setDefaultSort() {
    this.condition.sort_by = ["furigana"];
    this.condition.sort_desc = [false];
  }

  /** 開かれた際に選択された利用者にチェックを入れた状態を初期値にする */
  private resetProcessPatients() {
    if (this.selectPatients.length) {
      return this.unfilterPatients.map(item => {
        const target = this.selectPatients.filter(
          sp => sp.patient_id === item.patient_id
        );

        // 2026年6月以降は同一建物は全利用者チェックを入れた状態とする
        if (R8_CHANGE_LAW_BASE_YM <= this.yearmonth) {
          item.is_process_same_building = true;
        }
        if (0 < target.length) {
          item.is_process_fukusu_qualif = true;
          item.is_process_same_building = true;
        }
      });
    }
  }

  // 初期選択されている利用者を設定
  private setDefaultSelectPatients() {
    // 全利用者を選択
    this.selectPatients = [...this.unfilterPatients];

    // 2026年6月以降は全利用者の同一建物のチェックを入れた状態にする
    if (R8_CHANGE_LAW_BASE_YM <= this.yearmonth) {
      this.selectPatients.map(item => {
        item.is_process_fukusu_qualif = false;
        item.is_process_same_building = true;
      });
    }

    // 選択された利用者の複数名のチェックを入れる
    if (this.selectPatients !== undefined && this.selectPatients.length > 0) {
      this.selectPatients.map(item => {
        const target = this.selectedPatients.filter(
          sp => sp.patient_id === item.patient_id
        );

        if (0 < target.length) {
          item.is_process_fukusu_qualif = true;
          item.is_process_same_building = true;
        }
      });
    }
  }

  /** フィルターされた利用者 */
  private get FilterPatients() {
    if (!Array.isArray(this.unfilterPatients)) {
      return [];
    }

    if (this.condition === undefined) {
      return this.unfilterPatients;
    }

    return this.unfilterPatients
      .filter(p => {
        // 利用者名・ふりがな絞り込み
        if (!this.condition.search_cond.patient_name) {
          return true;
        }
        return (
          this.matchText(
            p.name.replace(/\s/g, ""),
            this.condition.search_cond.patient_name.replace(/\s/g, ""),
            this.condition.search_cond.patient_name_by
          ) ||
          this.matchText(
            p.furigana.replace(/\s/g, ""),
            this.condition.search_cond.patient_name.replace(/\s/g, ""),
            this.condition.search_cond.patient_name_by
          )
        );
      })
      .filter(p => {
        // 利用者ID絞り込み
        if (!this.condition.search_cond.display_id) return true;
        return this.matchText(
          p.display_id,
          this.condition.search_cond.display_id,
          this.condition.search_cond.display_id_by
        );
      })
      .map(p => {
        p.fixed_date = p.fixed_date.replaceAll("-", "/");
        return p;
      });
  }

  /** 並び替え変更 */
  private changeSort(items: PatientInfo[]) {
    if (!items.length || this.condition === undefined) return;

    this.condition.ids = items.map(patient => {
      return Number(patient.patient_id);
    });
  }

  /** データをグレーにする（請求履歴確定済のもの） ※データテーブルに渡す */
  private itemRowBackground(item: PatientInfo) {
    return item.invoice_history != "" ? "grey lighten-5" : "";
  }

  /** キーワード入力文字を検索条件に反映 ※データテーブルに渡す */
  private updateKeyword(newValue: string) {
    if (this.condition === undefined) return;

    this.condition.search_cond.patient_name = newValue;
  }

  /** 文字列一致を調べる */
  private matchText(
    subject: string,
    pattern: string,
    matchBy: number
  ): boolean {
    const matchIndex = subject.indexOf(pattern);
    switch (matchBy) {
      case 0: // 前方一致
        return matchIndex === 0;
      case 1: // 部分一致
        return matchIndex !== -1;
      default:
        return false;
    }
  }
}
